export default function() {
	// eslint-disable-next-line no-bitwise
	return `f${ (~~(Math.random() * 1e8)).toString(16) }`;
}
